import { zodToJsonSchema } from 'zod-to-json-schema'
import { ContractSchema } from './schemas/contract.js'

export const ContractJsonSchema = zodToJsonSchema(ContractSchema, {
  name: 'Contract',
  target: 'jsonSchema7',
})

export const ContractClaudeSchema = ContractJsonSchema
